import Component from './template';

export default Component;